<template>
  <base-modal
    title="EDIT FOLDER"
    :id="id"
    :value="value"
    extra-class="modal-sm"
    @shown="clear"
    @input="$emit('input', $event)"
  >
    <form data-vv-scope="edit-folder">
      <div class="form-group" :class="{ 'has-error': errors.has('edit-folder.name') }">
        <label for="edit-folder-name">Folder Name</label>
        <input id="edit-folder-name" class="form-control" name="name" type="text" v-validate="'required'" v-model="editFolderName">
        <span v-show="errors.has('edit-folder.name')" class="help-block">{{ errors.first('edit-folder.name') }}</span>
      </div>
    </form>
    <template #footer>
      <button class="btn green mt-ladda-btn ladda-button" data-style="expand-left"
              @click.prevent="editFolder(folderId, editFolderName)">
        <span class="ladda-label">OK</span>
      </button>
      <button class="btn default" data-dismiss="modal">Cancel</button>
    </template>
  </base-modal>
</template>

<script>
import {mapActions} from 'vuex';

import BaseModal from "../BaseModal";

export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    folderId: {
      required: true,
    },
    folderName: {
      required: true,
    },
  },
  data () {
    return {
      id: 'edit-folder-modal',
      editFolderName: '',
    }
  },
  methods: {
    ...mapActions({
      editFolderAction: 'EDIT_FOLDER_ACTION',
    }),
    clear() {
      this.editFolderName = this.folderName;
      this.$validator.reset();
    },
    editFolder(id, name) {
      this.$validator.validateAll('edit-folder').then((result) => {
        if (result) {
          this.editFolderAction({'folderId': id, 'newName' : name});
          $(`#${this.id}`).modal('hide');
        }
      });
    },
  },
  components: {BaseModal},
  emits: ['save', 'input'],
}
</script>



// WEBPACK FOOTER //
// EditFolderModal.vue?b2e27670